/**
 * The login queue window's words (ADR-127): its title, the label over the place, the estimate's forms, the sentence
 * shown in the estimate's place while there is none, the button and the bar's name for assistive technology. "Your
 * place" and the estimate's three forms are ADR-127's; the rest are drafts for the author. `{minutes}` is a whole
 * number of minutes.
 */
export const QUEUE = {
  title: "In the queue",
  place: "Your place",
  underMinute: "Under a minute",
  overHour: "Over an hour",
  aboutMinutes: "About {minutes} min",
  working: "Working out how long this will take.",
  leave: "Leave queue",
  progress: "Queue progress",
} as const;
